import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Row, Col } from 'reactstrap';

export const PartnerLogo = ({ brand, brandAssetsByPartner = {}, logoHeight, LogoComponent }) => {
  const offerDetails = useMemo(() => {
    return {
      brand,
      brandAssets: brandAssetsByPartner?.[brand],
    };
  }, [brand, brandAssetsByPartner]);

  return <LogoComponent offerDetails={offerDetails} height={logoHeight} />;
};

PartnerLogo.propTypes = {
  brand: PropTypes.string.isRequired,
  brandAssetsByPartner: PropTypes.shape({}),
  logoHeight: PropTypes.number.isRequired,
  LogoComponent: PropTypes.elementType.isRequired,
};

export const PartnerLogoGrid = ({
  brandsList,
  brandAssetsByPartner = {},
  logoHeight,
  LogoComponent,
  rowClassName = '',
  itemClassName = '',
}) => (
  <Row tag="ul" className={classnames('list-row list-unstyled flex-wrap', rowClassName)}>
    {brandsList.map(brand => (
      <Col tag="li" xs={6} md="auto" className={classnames('text-center', itemClassName)} key={brand}>
        <PartnerLogo
          brand={brand}
          brandAssetsByPartner={brandAssetsByPartner}
          logoHeight={logoHeight}
          LogoComponent={LogoComponent}
        />
      </Col>
    ))}
  </Row>
);

PartnerLogoGrid.propTypes = {
  brandsList: PropTypes.arrayOf(PropTypes.string).isRequired,
  brandAssetsByPartner: PropTypes.shape({}),
  logoHeight: PropTypes.number.isRequired,
  LogoComponent: PropTypes.elementType.isRequired,
  rowClassName: PropTypes.string,
  itemClassName: PropTypes.string,
};
